import { defineMessages } from "react-intl";

export const messages = defineMessages({
    notEligibleTitle: {
        id: "fastshift.not-eligible.title",
        defaultMessage: "You can’t access FastShift Portal",
        description: "Title for the not eligible display"
    },
    noLicenseDescription: {
        id: "fastshift.no-license.description",
        defaultMessage:
            "Your Atlassian account is not linked to a cloud license eligible to access FastShift Portal. Check your account status or {contactSupportLink} for further assistance.",
        description: "Description for the no license display"
    },
    notLinkedDescription: {
        id: "fastshift.not-linked.description",
        defaultMessage:
            "Your Atlassian account is not linked to any ongoing migration. If you believe you should have Portal access, {contactSupportLink}.",
        description: "Description for the not linked display"
    },
    contactSupportAnchorText: {
        id: "fastshift.not-eligible.contact-support-anchor-text",
        defaultMessage: "contact support",
        description: "Link text for contacting support"
    },
    goBackButton: {
        id: "fastshift.not-eligible.go-back-button",
        defaultMessage: "Go back",
        description: "Button text for going back to the previous display"
    },
    signInWithAnotherAccountButton: {
        id: "fastshift.not-eligible.sign-in-with-another-account",
        defaultMessage: "Sign in with another account",
        description: "Button text for signing in with another account"
    }
});
